import React from 'react';
import {
    Bug as BugSvg,
    HeartChunky as HeartChunkySvg,
    TicketChunky as TicketChunkySvg,
} from '@eventbrite/legacy-eds.iconography';
import { getAnalyticsClickHandler } from '@eventbrite/legacy-infra.site-analytics';
import { defineMessage } from 'react-intl';

const ACTION_DISCOVER = 'Discover';
const CATEGORY_HEADER = 'header';

// These were originally exported from core-js-global
// But ever since the refactor to @eventbrite/site-header, they
// seem to have removed these.
export const getLikesQuickLinks = (
    serverUrl: string,
    ebDomain: string,
    requestPath: string,
    publicId?: string,
    options?: { linkLabel: 'likes' | 'saved' },
) => [
    {
        url: `${serverUrl}/u/${publicId}/favorites/events`,
        content:
            options?.linkLabel === 'saved'
                ? defineMessage({ id: 'Saved', defaultMessage: 'Saved' })
                : defineMessage({ id: 'Likes', defaultMessage: 'Likes' }),
        iconType: <HeartChunkySvg />,
        iconColor: 'grey-800',
        onClick: getAnalyticsClickHandler(
            {
                requestPath,
                action: ACTION_DISCOVER,
                category: CATEGORY_HEADER,
            },
            {
                checkpointName: 'discover_header_link_clicked',
                domain: ebDomain,
            },
        ),
    },
];

export const getMyTicketsQuickLinks = (
    serverUrl: string,
    ebDomain: string,
    requestPath: string,
    publicId?: string,
) => [
    {
        url: `${serverUrl}/u/${publicId}/`,
        content: defineMessage({ id: 'Tickets', defaultMessage: 'Tickets' }),
        iconType: <TicketChunkySvg />,
        iconColor: 'grey-800',
        onClick: getAnalyticsClickHandler(
            {
                requestPath,
                action: ACTION_DISCOVER,
                category: CATEGORY_HEADER,
            },
            {
                checkpointName: 'discover_header_link_clicked',
                domain: ebDomain,
            },
        ),
    },
];

export const getBugQuickLink = () => [
    {
        url: 'https://docs.google.com/forms/d/e/1FAIpQLSfgAjPWo5RoQMiChhY1SlrrYycUnUUQjFTPkGAfCc1UCjXyWg/viewform',
        content: defineMessage({ id: 'Report a Bug', defaultMessage: 'Report a Bug' }),
        iconType: <BugSvg />,
    },
];
